import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormBuilder, FormControl, FormGroup } from '@ngneat/reactive-forms';

import { ManifestsFacadeService } from '@digital-platform/manifests/services';

interface InputValue {
  value: string;
  index: number;
  isValid?: boolean;
}

interface ResendSignatureDialogForm {
  emailAddress: FormControl<string>;
}

@Component({
  selector: 'digital-platform-access-code',
  templateUrl: './access-code.component.html',
  styleUrls: ['./access-code.component.scss'],
})
export class AccessCodeComponent {
  public form: FormGroup<ResendSignatureDialogForm>;
  codeLength = 6;
  hasValidToken = false;
  hasTokenError = false;
  docusignUrl = '';
  isLoading = false;
  inputValues: InputValue[] = new Array(this.codeLength);
  enableOptionalFLow = false;

  constructor(
    private manifestFacadeService: ManifestsFacadeService,
    private fb: FormBuilder
  ) {
    for (let i = 0; i < this.codeLength; i++) {
      this.inputValues[i] = {
        value: '',
        index: i,
      };
    }

    this.form = this.fb.group({
      emailAddress: ['', Validators.email],
    });
  }

  updateChar(event: any, index: number) {
    if (event.key === 'Tab') {
      return;
    }

    const input = event.target;
    const next = input.nextElementSibling;

    if (next && input.value) {
      next.focus();
      next.select();
    }

    if (index === this.codeLength - 1 && input.value) {
      input.blur();
    }

    this.inputValues[index].value = input.value;
    this.inputValues[index].isValid = true;
  }

  submitCode(): void {
    this.hasTokenError = false;

    const code = this.inputValues.map((i) => i.value).join('');

    this.isLoading = true;

    this.manifestFacadeService.validateAccessCode(code).subscribe({
      next: (docusignUrl) => {
        this.isLoading = false;
        if (
          docusignUrl === null ||
          docusignUrl === undefined ||
          docusignUrl.length === 0
        ) {
          this.hasTokenError = true;
          this.inputValues.forEach((i) => (i.isValid = false));
          return;
        }

        this.docusignUrl = docusignUrl;
        this.hasValidToken = true;
        this.navToSign();
      },
      error: (err) => {
        this.isLoading = false;
        this.hasTokenError = true;
        this.inputValues.forEach((i) => (i.isValid = false));
        console.error('Error validating access code:', err);
      },
    });
  }

  isAccessCodeFull(): boolean {
    const code = this.inputValues.map((i) => i.value).join('');
    return code.length === this.codeLength;
  }

  navToSign(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    window.open(this.docusignUrl, '_blank');
  }
}
